import { useReactiveVar } from '@apollo/client';
import { useNavigation } from '@react-navigation/native';
import { Button, Meta, theme } from 'aimo-ui';
import AccountContext from 'context/AccountContext';
import { hasAcceptedTerms } from 'hooks/useHasAcceptance';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useActiveElementStore } from 'stores/activeElementStore';
import { useAuthStore } from 'stores/authStore';
import {
  featureCountryCode,
  futureFeatureCountryCode,
} from 'states/persistInStorage';
import { StyledWrapper } from 'styles/ContainerStyles';
import { RootNavProps } from 'types/navigation';
import { changeFutureAppCountryCode } from 'utils/countryUtils';
import { handleElPress } from 'utils/mapUtils';
import { testIdentifiers } from 'utils/testIdentifiers';
import { useUiStore } from 'stores/uiStore';

const UpdateFeatureCountryModal: React.FC<{ isAutomatic?: boolean }> = ({
  isAutomatic,
}) => {
  const { t } = useTranslation();
  const currentCountry = useAuthStore((state) => state.currentCustomerCountry);
  const appCountry = useReactiveVar(featureCountryCode);
  const futureAppCountry = useReactiveVar(futureFeatureCountryCode);
  const uid = useActiveElementStore((state) => state.activeElement);
  const {
    customer: { acceptances },
  } = useContext(AccountContext);
  const { navigate, goBack } = useNavigation<RootNavProps>();

  const countryUpdate = () => {
    if (!isAutomatic) {
      const hasAcceptedTermsAppCountry =
        futureAppCountry &&
        hasAcceptedTerms(futureAppCountry, 'TERMS_ACCEPTED', acceptances);

      if (hasAcceptedTermsAppCountry) {
        featureCountryCode(futureAppCountry);
      } else {
        changeFutureAppCountryCode(futureAppCountry);
        navigate('approveTermsAppLocation');
      }
      return useUiStore.getState().setSheetModal('');
    }
    useUiStore.getState().setSheetModal('appLocation');
  };

  const onBackPress = () => {
    useUiStore.getState().setSheetModal('');
    handleElPress(uid, { latitude: 0, longitude: 0 });
    goBack();
  };

  const renderDescription = () => {
    return !isAutomatic
      ? t('parking.updateLocation.description', {
          targetCountry: t(`account.appLocations.${currentCountry}`),
        })
      : t('parking.updateLocation.autoChangeDesc', {
          currentCountry: t(`account.appLocations.${currentCountry}`),
          appCountry: t(`account.appLocations.${appCountry}`),
        });
  };
  return (
    <StyledWrapper mb={0}>
      <StyledWrapper maxWidth={335} center mb={40}>
        <Meta
          center
          color={theme.colors.gray300}
          testID="app-location-description">
          {renderDescription()}
        </Meta>
      </StyledWrapper>
      <StyledWrapper mb={0}>
        <StyledWrapper>
          <Button
            testID="app-update-button"
            size="l"
            text={t('parking.updateLocation.updateLocation')}
            onPress={countryUpdate}
          />
        </StyledWrapper>
        <StyledWrapper mb={0}>
          <Button
            {...testIdentifiers('app-update-cancel-button')}
            size="l"
            buttonType="tertiary"
            text={t('button.cancel')}
            onPress={onBackPress}
          />
        </StyledWrapper>
      </StyledWrapper>
    </StyledWrapper>
  );
};

export default UpdateFeatureCountryModal;
